import { render, staticRenderFns } from "./InfoboxMessage.vue?vue&type=template&id=ad2a1fde&scoped=true&"
import script from "./InfoboxMessage.vue?vue&type=script&lang=js&"
export * from "./InfoboxMessage.vue?vue&type=script&lang=js&"
import style0 from "./InfoboxMessage.vue?vue&type=style&index=0&id=ad2a1fde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2a1fde",
  null
  
)

export default component.exports